export default {
  USER_PASSWORD_REPOSITORY: Symbol.for('USER_PASSWORD_REPOSITORY'),
  UPDATE_USER_PASSWORD_COMMAND: Symbol.for('UPDATE_USER_PASSWORD_COMMAND'),
};
